<script>
import Cocktail from './Cocktail.svelte'
import CockTailsVideo from '../../videos/CocktailsVideo.svelte'
import Popup from './Popup.svelte' 

let cocktails = [
    {
        id:0,
        img:'balsam-latte',
        title:'Balsam Latte',
        video:'https://youtu.be/RsINR-xAxNk',
        desc:'Fill a high Old Fashioned glass with ice. Brew the espresso directly in the glass, add Riga Black Balsam Espresso. Heat the milk in the pitcher, pour over the mixture of espresso and balsam. Serve immediately.',
        content:[
            {ingredient:'Riga Black Balsam Espresso',value:'30 ml'},
            {ingredient:'Espresso (1 shot)',value:'20-25 ml'},
            {ingredient:'Fresh frothed whole milk',value:'120 ml'},
        ],
    },
    {
        id:1,
        img:'manic-botanic',
        title:'Manic Botanic',
        video:'https://youtu.be/9klE2hZz9Ok',
        desc:'Pour all the ingredients into a cooled mixing glass with ice and shake well. Pour in an elegant cocktail glass.',
        content:[
            {ingredient:'Riga Black Balsam Espresso',value:'35 ml'},
            {ingredient:'Rooster Rojo Reposado Tequila',value:'25 ml'},
            {ingredient:'Italicus Rosolio Di Bergamotto L\'Aperitivo',value:'20 ml'},
        ],
    },
    {
        id:2,
        img:'cherry-espresso',
        title:'Cherry Espresso',
        video:'https://youtu.be/ffNaGQxy1BM',
        desc:'Fill and Old Fashioned glass with ice. Add Riga Black Balsam Espresso, cherry juice and a slice of orange. Mix and enjoy.',
        content:[
            {ingredient:'Riga Black Balsam Espresso',value:'1 Part'},
            {ingredient:'Cherry Juice',value:'3 Parts'},
            {ingredient:'A slice of orange',value:''},
        ],
    },
]

let popupVisible = false
let selectedCocktail = {}
let handlePopup = (e) => {
    popupVisible = true
    selectedCocktail = e.detail
}
let switchCocktail = (delta) => {
    popupVisible = false
    let newSelection = selectedCocktail.id + delta
    if( newSelection < 0 ) newSelection = cocktails.length - 1
    if( newSelection >= cocktails.length ) newSelection = 0

    setTimeout( () => {
        selectedCocktail = cocktails[ newSelection ]    
        popupVisible = true
    } , 200 )

}
</script>

<style>
.title{ margin-top:100px; position:relative; }
.title h1{ font-size: 27px; line-height: 30px; text-align: center; letter-spacing: 1.5px; text-transform: uppercase; color: #E6E7E8; margin:0px 30px; }
.title .side{ background-repeat:no-repeat; background-size:contain; height:50px; }
.title .left{ background-image:url('./res/title-left.svg'); background-position-x:right; }
.title .right{ background-image:url('./res/title-right.svg');  background-position-x:left; }

@media (max-width: 768px){
    .title .side{ margin:0px 20px; }
} 
</style>

{#if popupVisible}
    <Popup cocktail={selectedCocktail} on:close={ ()=>{ popupVisible = false } } on:prev={() => { switchCocktail(-1) } } on:next={ () => { switchCocktail(+1) } } />
{/if}

<div id="cocktails" style="position:relative; overflow:hidden;">
    <CockTailsVideo />

    <div class="title columns">
        <div class="left side column"></div>
        <div class="column is-narrow">
            <h1>COCKTAILS</h1>
        </div>
        <div class="right side column"></div>
    </div>

    <div class="container">    

        <div class="columns">
            {#each cocktails as cocktail, i}
                <div class="column">
                    <Cocktail {cocktail} on:popup={handlePopup} delay={300*i} />
                </div>
            {/each}
        </div>
        
    </div>

</div>

<hr />